/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Passkey_Toast_BodyInputs */



/**
* | output |
* | --- |
* | "Passkey sign-in is not available on this device yet." |
*
* @param {Portalsignin_Passkey_Toast_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portalsignin_passkey_toast_body = /** @type {((inputs?: Portalsignin_Passkey_Toast_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Passkey_Toast_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Passkey sign-in is not available on this device yet.")
});